
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ChartsModule } from 'ng2-charts';
import { ChartistModule } from 'ng-chartist';
import { CdkTableModule } from '@angular/cdk/table';
import { ChartslibModule } from './template/charts/chartslib.module';
import { AuthGuardInicialService } from './structure/service/auth/auth-guard-inicial.service';
import { AuthGuardService } from './structure/service/auth/auth-guard.service';
import { JwtService } from './structure/service/auth/jwt.service';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutes } from './app.routing';
import { AppComponent } from './app.component';

import { FlexLayoutModule } from '@angular/flex-layout';
import { FullComponent } from './template/layouts/full/full.component';
import { AppBlankComponent } from './template/layouts/blank/blank.component';
import { AppHeaderComponent } from './template/layouts/full/header/header.component';
import { AppSidebarComponent } from './template/layouts/full/sidebar/sidebar.component';
import { AppBreadcrumbComponent } from './template/layouts/full/breadcrumb/breadcrumb.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DemoMaterialModule } from './template/demo-material-module';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

import { SharedModule } from './shared/shared.module';
import { SpinnerComponent } from './shared/spinner.component';
import { HomeComponent } from './features/home/home.component';
import { mailService, mailGlobalVariable } from './template/apps/mailbox/mail.service';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { AcessibilidadeComponent } from './features/acessibilidade/acessibilidade.component';
import { DatePipe, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { MessageService } from './structure/service/message.service';
import { ApiService } from './structure/service/api.service';
import { DialogCustomComponent } from './structure/components/dialog-custom/dialog-custom.component';
import { SanitizeHtmlPipe } from './shared/pipes/sanitize.pipe';

import { ConfigsLoaderService } from '../app/services/configs-loader.service'
import { gridPaginatorTranslate } from './structure/extends/mat-paginator-extends';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { AgGridModule } from 'ag-grid-angular'
import { MatTableExporterModule } from 'mat-table-exporter';
import { APP_INITIALIZER } from '@angular/core';
import { GoogleChartsModule } from 'angular-google-charts'
import { RequestInterceptor } from './structure/service/auth/request.interceptor';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
    suppressScrollX: true,
    wheelSpeed: 2,
    wheelPropagation: true
};

@NgModule({
    declarations: [
        AppComponent,
        FullComponent,
        AppHeaderComponent,
        SpinnerComponent,
        AppBlankComponent,
        AppSidebarComponent,
        AppBreadcrumbComponent,
        HomeComponent,
        AcessibilidadeComponent,
        DialogCustomComponent,
        SanitizeHtmlPipe,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        DemoMaterialModule,
        FormsModule,
        FlexLayoutModule,
        HttpClientModule,
        PerfectScrollbarModule,
        SharedModule,
        NgMultiSelectDropDownModule.forRoot(),
        RouterModule.forRoot(AppRoutes),
        AgGridModule,
        MatTableExporterModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        GoogleChartsModule
    ],
    providers: [

        {
            provide: APP_INITIALIZER,
            useFactory: appInitializerFactory,
            deps: [ConfigsLoaderService],
            multi: true
        },
      { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
        { provide: LocationStrategy, useClass: HashLocationStrategy},
        { provide: MatPaginatorIntl, useValue: gridPaginatorTranslate() },
        {
            provide: PERFECT_SCROLLBAR_CONFIG,
            useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
        }, mailService, mailGlobalVariable, ApiService,  MessageService, JwtService, AuthGuardService,AuthGuardInicialService,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: RequestInterceptor,
          multi: true
        },DatePipe

    ],
    schemas: [
      CUSTOM_ELEMENTS_SCHEMA,
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }

export function appInitializerFactory(configsLoaderService: ConfigsLoaderService) {
  return () => configsLoaderService.loadConfigs();
}
